/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { TaxRateDto } from './tax-rates.dto';
import { TaxRatesMapper } from './tax-rates.mapper';

@Injectable()
export class TaxRateRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAll(tmpCredentials?: boolean): Observable<TaxRateDto[]> {
    return this.httpGet(
      '/accounting/tax-rates',
      { tmpCredentials },
      identity(),
      arrayOf(TaxRatesMapper),
    );
  }
}
